import styled from 'styled-components';

const DarkContainer = styled.section`
  background: #222;
  display: block;
  overflow-y: hidden;
  color: #fff;
  width: 100%;

  padding: 25px;

  height: 100%;

  &#about {
    padding-bottom: 10px;
  }

  &#clients {
    padding-top: 15px;
  }

  #cont {
    display: flex;
    flex-direction: column;
    max-width: 60%;
    height: 100%;
    margin-top: 15px;
    margin-bottom: 15px;

    margin-left: auto;
    margin-right: auto;

    h2 {
      font-family: 'Yanone Kaffeesatz', 'Noto Mono', 'Arial Narrow', sans-serif;
      font-weight: 400;
      font-size: 24px;
      margin-bottom: 15px;
    }

    h1 {
      font-family: 'Yanone Kaffeesatz', 'Noto Mono', sans-serif;
      font-weight: 400;
      font-size: 28px;
      margin-bottom: 15px;
    }

    p {
      text-align: left;
      line-height: 1.4;
      margin-bottom: 10px;
    }
  }

  @media screen and (max-width: 700px) {
    #cont {
      text-align: center;
      max-width: 90%;
      width: 90%;
    }
  }
`;

export default DarkContainer;
